import { dispatchAndUnwrap } from 'helpers/api';
import { masterDataApi } from 'services/masterDataApi';
import { skipAgreements, setAgreements } from 'store/agreementsSlice';
import { hasValue } from 'swipeclock-frontend';

export async function agreeToAllAgreements(
  dispatch,
  agreements,
  masterEmployeeId
) {
  const response = dispatch(
    masterDataApi.endpoints.saveEmployeeAgreements.initiate({
      agreements,
      masterEmployeeId: `${masterEmployeeId}`,
    })
  );

  const data = await response.unwrap();
  return data;
}

export function checkAgreements(agreements, user) {
  // Check if the user is impersonating. If so, return false.
  // This is an additional safeguard, even though retrieveAgreements in the loader should have already handled this scenario.
  if (user?.impersonating) {
    return false;
  }

  return hasValue(agreements);
}

export const retrieveAgreements = async (dispatch, user) => {
  // Skip if impersonating
  if (user?.impersonating) {
    dispatch(skipAgreements());
    return [];
  }

  // Skip of no masterEmployeeId
  if (!user?.masterEmployeeId) {
    dispatch(skipAgreements());
    return [];
  }

  const response = await dispatchAndUnwrap(
    dispatch,
    masterDataApi.endpoints.getEmployeeAgreements,
    {
      masterEmployeeId: `${user?.masterEmployeeId}`,
    }
  );

  // Side-effect to set agreements
  dispatch(setAgreements({ agreements: response }));
  return response;
};
